import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { ILogoutModalProps } from "../interface";

import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { Controller, useForm } from "react-hook-form";
import { useEffect } from "react";
import { ReactNode } from "react";
import { useModal } from "@/app/hooks/ui_hooks/useModal";

export interface IDeleteCartItemModalState {
  handleDeletePetCartRow?: (rowItemId: string, urid: string, itemName: string, reason_of_deletion: string) => void;
  onConfirmDelete?: (reason_of_deletion: string) => void | Promise<void>;
  rowItemId?: string;
  urid?: string;
  itemName?: string;
  reason_of_deletion?: string;
  title?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  reasonPlaceholder?: string;
  description?: ReactNode;
}

const DeleteCartItemModal: React.FC<ILogoutModalProps> = () => {
  const modalState = useModalState("CART_REMOVE_ITEM") as IDeleteCartItemModalState | null;
  const isModalVisible = useModal("CART_REMOVE_ITEM");
  const {
    handleDeletePetCartRow,
    onConfirmDelete,
    rowItemId,
    urid,
    itemName,
    title,
    primaryButtonText,
    secondaryButtonText,
    reasonPlaceholder,
    description,
  } = modalState || {};

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      otherReason: "",
    },
  });

  useEffect(() => {
    if (isModalVisible) {
      formHook.reset({ otherReason: "" });
    }
  }, [isModalVisible]);

  return (
    <ModalPrompt
      modalId="CART_REMOVE_ITEM"
      button={{
        primaryButtonText: primaryButtonText || "Remove",
        secondaryButtonText: secondaryButtonText || "No",
        primaryButtonDisabled: formHook.watch("otherReason") ? false : true,
        primaryCallback: () => {
          if (onConfirmDelete) {
            onConfirmDelete(formHook.watch("otherReason"));
            return;
          }
          if (handleDeletePetCartRow) {
            handleDeletePetCartRow(rowItemId, urid, null, formHook.watch("otherReason"));
          }
        },
        shouldHideOnClick: true,
      }}
      title={title || "Enter reason"}
      content={
        <span className="text-xs">
          <p className="text-red-500 text-sm font-medium pb-4">
            {description || (
              <>
                You are removing <strong>{itemName}</strong> service from cart. Please enter the reason for removing
                this service.
              </>
            )}
          </p>
          <Controller
            name="otherReason"
            control={formHook.control}
            rules={{
              required: "Please provide a reason.",
              validate: (value) => value.trim() !== "" || "Reason cannot be blank.",
            }}
            render={({ field }) => (
              <textarea
                {...field}
                rows={2}
                placeholder={reasonPlaceholder || "Enter your reason here"}
                className="w-full p-2 border border-gray-300 rounded-md text-sm"
              />
            )}
          />
        </span>
      }
    />
  );
};

export default DeleteCartItemModal;
